import { render } from "./ticket_details.vue?vue&type=template&id=194fb345&scoped=true"
import script from "./ticket_details.vue?vue&type=script&lang=js"
export * from "./ticket_details.vue?vue&type=script&lang=js"

import "./ticket_details.vue?vue&type=style&index=0&id=194fb345&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194fb345"]])

export default __exports__